module.exports = __webpack_public_path__ + "static/img/hyper-tube-wall-hole_64.a8fbfad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hyper-tube-wall-hole_64.png
// module id = H9j4
// module chunks = 0